import React from 'react'
import ContactBanner from '../Component/contact/ContactBanner'
import SEO from '../Component/SEO'
export default function Contact() {
  return (
   <>
   <SEO
  title="Contact TROGO | Transport & Logistics Support"
  description="Get in touch with TROGO for passenger rides, goods transport, heavy vehicle services or partnerships."
  keywords="contact trogo, transport support, logistics help"
  url="https://www.togoodsdraft.com/contact"
/>

   <ContactBanner/>
   </>
  )
}
